import { Badge, BadgeProps } from '@chakra-ui/react';
import { FC } from 'react';

interface ClassificationMethodBadgeProps extends BadgeProps {
  method?: string;
}

export const getMethodColor = (method: string): string => {
  switch (method?.toLowerCase()) {
    case 'embedding':
      return 'blue';
    case 'llm':
      return 'purple';
    default:
      return 'gray';
  }
};

export const ClassificationMethodBadge: FC<ClassificationMethodBadgeProps> = ({
  method,
  ...props
}) => (
  <Badge
    colorScheme={getMethodColor(method || 'unknown')}
    fontSize="xs"
    fontWeight="medium"
    {...props}
  >
    {method || 'unknown'}
  </Badge>
);
